import React from "react";
import styled from "styled-components";
import ButtonWithText from "./Button";

const Container = styled.div`
    position: relative;
    display: inline-block;
`;

const SubButtons = styled.div`
    position: absolute;
    bottom: 100%;
    left: 100%;
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    gap: 8px;
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease-in-out;
    padding: 8px 0;
`;

const HoverContainer = styled(Container)`
    &:hover ${SubButtons} {
        opacity: 1;
        visibility: visible;
        transform: translateX(-100%);
    }
`;

const FloatingButtons = ({ children }) => {
    return (
        <HoverContainer>
            <ButtonWithText icon="add" iconType="material" variant="primary" buttonStyle="default" size="circle" />
            <SubButtons>{children}</SubButtons>
        </HoverContainer>
    );
};

export default FloatingButtons;
